import { POST_READING_ACTION_TYPES, ACTIVITY_ACTION_TYPES } from './action_types';
import getPostReadingData from '../../services/api/post_reading';
import { setPostReadingAnswer } from '../../services/api/state';
import { findActivityAttempts } from '../../lib/answers';
import { reportSelection } from './reporting';

export function getPostReadingQuestions(bookId) {
  return (dispatch, getState) => {
    const { hasPostReading } = getState().eReader.config;
    if (!hasPostReading) {
      return dispatch({
        type: POST_READING_ACTION_TYPES.SET_ALL_QUESTIONS,
        payload: [],
      });
    }

    return getPostReadingData(bookId).then((questions) => {
      dispatch({
        type: POST_READING_ACTION_TYPES.SET_ALL_QUESTIONS,
        payload: questions,
      });

      return dispatch(updateRemainingPostReadingQuestions());
    });
  };
}

export function answerQuestion(
  questionId,
  correct,
  currentAnswer,
) {
  return (dispatch, getState) => {
    const { eReader } = getState();
    const { bookInfo: { attempts: bookAttempts }, postReading, accurateResponseData, answers: allAnswers } = eReader;
    const questionIndex = postReading.questions.findIndex(question => (question.questionId === questionId));
    const {
      type,
      correctAnswer,
      answers,
      answersType,
    } = postReading.questions[questionIndex];

    const prevAttempts =
      findActivityAttempts(allAnswers.postReading, {
        identifier: 'questionId',
        id: questionId,
        bookAttempts,
      }) || 0;
    const attempts = prevAttempts + 1;

    let updatedResponseData = {
      ...accurateResponseData,
    };

    if (attempts === 1) {
      if (correct) {
        updatedResponseData = {
          ...updatedResponseData,
          totalCorrect: updatedResponseData.totalCorrect + 1,
        };
        dispatch({
          type: ACTIVITY_ACTION_TYPES.ANSWER_CORRECT,
          payload: {},
        });
      } else {
        updatedResponseData = {
          ...updatedResponseData,
          totalIncorrect: updatedResponseData.totalIncorrect + 1,
        };
        dispatch({
          type: ACTIVITY_ACTION_TYPES.ANSWER_INCORRECT,
          payload: {},
        });
      }
    }
    if (correct) {
      dispatch({
        type: POST_READING_ACTION_TYPES.ANSWER_CORRECT,
        payload: {
          questionId,
        },
      });
    }

    updatedResponseData = {
      ...updatedResponseData,
      totalResponses: updatedResponseData.totalResponses + 1,
    };

    setPostReadingAnswer(questionId, correct, attempts, bookAttempts, updatedResponseData);

    dispatch(reportSelection({
      activityType: `${type}.${answersType}`,
      questionId,
      questionIndex: questionIndex + 1,
      possibleAnswers: answers,
      answerChosen: currentAnswer,
      correctAnswer,
      attemptNumber: attempts,
      isCorrect: correct,
    }));

    return dispatch({
      type: POST_READING_ACTION_TYPES.ANSWER,
      payload: {
        questionId,
        correct,
        attempts,
        bookAttempts,
      },
    });
  };
}

export const updateRemainingPostReadingQuestions = () => (dispatch, getState) => {
  const {
    answers,
    postReading: { questions },
  } = getState().eReader;

  const remainingQuestions = questions.reduce((acc, question) => {
    const answer = answers.postReading.find(({ questionId }) => questionId === question.questionId);

    if (!answer || (answer.attempts < 2 && !answer.correct)) {
      return [...acc, question];
    }

    return acc;
  }, []);

  return dispatch({
    type: POST_READING_ACTION_TYPES.SET_REMAINING_QUESTIONS,
    payload: remainingQuestions,
  });
};
